import Icon from "assets/icons";
import React from "react";
import { ModalSubTitleType } from "./enum";

export default function ModalCustomTitle(props: {
  title: string;
  subTitleType: ModalSubTitleType;
  subTitle?: string | React.ReactElement;
}) {
  return (
    <React.Fragment>
      {props.title}
      <div className="modalCustom_subTitle">
        {props.subTitleType === ModalSubTitleType.CUSTOM && props.subTitle}
        {props.subTitleType === ModalSubTitleType.PARTICIPANT && (
          <React.Fragment>
            <Icon.UserCircle /> {props.subTitle}
          </React.Fragment>
        )}
        {props.subTitleType === ModalSubTitleType.ORGANIZATION && (
          <React.Fragment>
            <Icon.OrgDefaultLogoThick /> {props.subTitle}
          </React.Fragment>
        )}
        {props.subTitleType === ModalSubTitleType.DATETIME && (
          <React.Fragment>
            <Icon.ClockIcon /> {props.subTitle}
          </React.Fragment>
        )}
        {props.subTitleType === ModalSubTitleType.LOCATION && (
          <React.Fragment>
            <Icon.Location /> {props.subTitle}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}
